let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("eNmuD"), load("cM9em"), load("fr9NE"), load("3vo2B")]).then(() => parcelRequire('6qBzG'));